
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ohWCq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3936ca9bbf2fddae$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b5aBe = parcelRequire("b5aBe");
const $3936ca9bbf2fddae$var$LoomPanel = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5aBe.LoomPanel), props);
var $3936ca9bbf2fddae$export$2e2bcd8739ae039 = $3936ca9bbf2fddae$var$LoomPanel;

});
parcelRegister("b5aBe", function(module, exports) {

$parcel$export(module.exports, "LoomPanel", () => $7730531009b3c840$export$761622e58ea33251);

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $45jFk = parcelRequire("45jFk");

var $5BHhW = parcelRequire("5BHhW");

var $4BRXm = parcelRequire("4BRXm");

var $7Jak7 = parcelRequire("7Jak7");

var $cSD7y = parcelRequire("cSD7y");

var $cIsNW = parcelRequire("cIsNW");

var $hjf9X = parcelRequire("hjf9X");
// Loom panel that launched with M2.5
const $7730531009b3c840$var$LoomPanelOld = ()=>{
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $45jFk.useLoomTouchpointWithProjectType)();
    if (loomTouchpointVariant === (0, $4BRXm.LoomTouchpointVariant).NONE) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: {
            attributes: {
                loomTouchpointVariant: loomTouchpointVariant
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjf9X.LoomCoUsePanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Jak7.LoomRecorderLoadingBlanket), null));
};
// Feature gated Loom panel component for Loom JSM agent experiment
const $7730531009b3c840$var$LoomPanelWithJSM = ()=>{
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $5BHhW.useLoomTouchpointVariant)();
    const { showCoUsePanel: showCoUsePanel, showLoadingBlanket: showLoadingBlanket } = (0, $cIsNW.useLoomSupportedProjectType)();
    if (loomTouchpointVariant === (0, $4BRXm.LoomTouchpointVariant).NONE || !showCoUsePanel && !showLoadingBlanket) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: {
            attributes: {
                loomTouchpointVariant: loomTouchpointVariant,
                showLoomCoUsePanel: showCoUsePanel,
                showLoomLoadingBlanket: showLoadingBlanket
            }
        }
    }, showCoUsePanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjf9X.LoomCoUsePanel), null), showLoadingBlanket && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Jak7.LoomRecorderLoadingBlanket), null));
};
const $7730531009b3c840$export$761622e58ea33251 = (0, $cSD7y.componentWithFG)('loom_jsm_experiment_controller', $7730531009b3c840$var$LoomPanelWithJSM, $7730531009b3c840$var$LoomPanelOld);

});
parcelRegister("7Jak7", function(module, exports) {

$parcel$export(module.exports, "LoomRecorderLoadingBlanket", () => $b15435713a00e6a9$export$333b15e6d765b856);

var $5uXOq = parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $k8nZq = parcelRequire("k8nZq");

var $fNobW = parcelRequire("fNobW");

var $gwIPs = parcelRequire("gwIPs");

var $apCzy = parcelRequire("apCzy");
const $b15435713a00e6a9$export$333b15e6d765b856 = ()=>{
    const [{ isBlanketShown: isBlanketShown, isPolling: isPolling }] = (0, $apCzy.useLoomRecorderLoadingBlanket)();
    // the blanket has to be on top of everything. If we use layers.blanket, it will be behind issue view modals.
    return isBlanketShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8nZq.default), {
        zIndex: (0, $gwIPs.layers).spotlight + 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), {
        isTinted: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "loom-recorder-loading-blanket",
        hold: isPolling
    }));
};

});

parcelRegister("cIsNW", function(module, exports) {

$parcel$export(module.exports, "useLoomSupportedProjectType", () => $8d8856135b782f95$export$92b42caa4f813468);

var $2vSU6 = parcelRequire("2vSU6");

var $kVVL1 = parcelRequire("kVVL1");
const $8d8856135b782f95$var$SUPPORTED_CO_USE_PROJECT_TYPES = [
    (0, $2vSU6.CORE_PROJECT),
    (0, $2vSU6.SOFTWARE_PROJECT)
];
const $8d8856135b782f95$var$SUPPORTED_LOADING_BLANKET_PROJECT_TYPES = [
    (0, $2vSU6.CORE_PROJECT),
    (0, $2vSU6.SOFTWARE_PROJECT),
    (0, $2vSU6.SERVICE_DESK_PROJECT)
];
const $8d8856135b782f95$export$92b42caa4f813468 = ()=>{
    const project = (0, $kVVL1.useSelector)((state)=>state.entities?.project);
    const projectType = project?.projectType;
    const showCoUsePanel = projectType && $8d8856135b782f95$var$SUPPORTED_CO_USE_PROJECT_TYPES.includes(projectType);
    const showLoadingBlanket = projectType && $8d8856135b782f95$var$SUPPORTED_LOADING_BLANKET_PROJECT_TYPES.includes(projectType);
    return {
        showCoUsePanel: showCoUsePanel,
        showLoadingBlanket: showLoadingBlanket
    };
};

});

parcelRegister("hjf9X", function(module, exports) {

$parcel$export(module.exports, "LoomCoUsePanel", () => $b185c04079e2274f$export$469c500eeadb1acb);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $7CMCs = parcelRequire("7CMCs");

var $hxqfC = parcelRequire("hxqfC");

var $2HI8Y = parcelRequire("2HI8Y");

var $1gC8Z = parcelRequire("1gC8Z");

var $6ypLV = parcelRequire("6ypLV");

var $giCf8 = parcelRequire("giCf8");

var $g5X3G = parcelRequire("g5X3G");

var $67BtE = parcelRequire("67BtE");
const $b185c04079e2274f$var$LOOM_APP_NAME = 'Loom';
const $b185c04079e2274f$var$LOOM_APP_TYPE = 'com.atlassian.jira.issue.loom';
const $b185c04079e2274f$export$ac90a5534d384989 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $hxqfC.connect)((state)=>({
        isInsertLoomLinkOpened: (0, $6ypLV.isInsertLoomLinkOpenedSelector)(state),
        insertLoomLinkClickedCount: (0, $6ypLV.insertLoomLinkClickedCountSelector)(state),
        links: (0, $giCf8.webLinksWithApplicationIdSelector)(state, (0, $giCf8.generateApplicationId)($b185c04079e2274f$var$LOOM_APP_NAME, $b185c04079e2274f$var$LOOM_APP_TYPE))
    }), (dispatch)=>({
        onInsertLink: (url)=>dispatch((0, $1gC8Z.createWebLinkRequest)((0, $g5X3G.toHref)(url), 'Loom video', '', {
                type: $b185c04079e2274f$var$LOOM_APP_TYPE,
                name: $b185c04079e2274f$var$LOOM_APP_NAME
            })),
        onDeleteLink: (id)=>dispatch((0, $1gC8Z.deleteWebLinkRequest)(id)),
        onShowInsertLoomLinkForm: ()=>dispatch((0, $2HI8Y.showInsertLoomLinkForm)()),
        onHideInsertLoomLinkForm: ()=>dispatch((0, $2HI8Y.hideInsertLoomLinkForm)())
    })))((0, $67BtE.LoomCoUseView));
const $b185c04079e2274f$export$469c500eeadb1acb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "loom-videos-section-container",
        packageName: "issueViewBase",
        teamName: "bento",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b185c04079e2274f$export$ac90a5534d384989, props));

});
parcelRegister("6ypLV", function(module, exports) {

$parcel$export(module.exports, "insertLoomLinkClickedCountSelector", () => $ac15b976a392e0d8$export$d4e1e55c7928c872);
$parcel$export(module.exports, "isInsertLoomLinkOpenedSelector", () => $ac15b976a392e0d8$export$25945e2a4ec61683);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");
const $ac15b976a392e0d8$var$loomRootSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.loom);
const $ac15b976a392e0d8$export$d4e1e55c7928c872 = (0, $dGvGJ.createSelector)($ac15b976a392e0d8$var$loomRootSelector, (loom)=>loom.insertLoomLinkClickedCount);
const $ac15b976a392e0d8$export$25945e2a4ec61683 = (0, $dGvGJ.createSelector)($ac15b976a392e0d8$export$d4e1e55c7928c872, (insertLoomLinkClickedCount)=>insertLoomLinkClickedCount > 0);

});

parcelRegister("67BtE", function(module, exports) {

$parcel$export(module.exports, "LoomCoUseView", () => $ada393559e8fa83c$export$f68e18636ec96e0e);

var $5uXOq = parcelRequire("5uXOq");

var $dWt6p = parcelRequire("dWt6p");

var $414Wj = parcelRequire("414Wj");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $f7CQF = parcelRequire("f7CQF");

var $fdGwF = parcelRequire("fdGwF");

var $9PU8D = parcelRequire("9PU8D");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $enHDY = parcelRequire("enHDY");

var $8NFbq = parcelRequire("8NFbq");

var $aW8qI = parcelRequire("aW8qI");

var $8gnpg = parcelRequire("8gnpg");
function $ada393559e8fa83c$var$isSmartAndNotFailedToDeleteWebLink(link) {
    return 'smartLinkId' in link && !('deleteFailed' in link);
}
const $ada393559e8fa83c$export$f68e18636ec96e0e = ({ isInsertLoomLinkOpened: isInsertLoomLinkOpened, insertLoomLinkClickedCount: insertLoomLinkClickedCount, links: links, onInsertLink: onInsertLink, onDeleteLink: onDeleteLink, onShowInsertLoomLinkForm: onShowInsertLoomLinkForm, onHideInsertLoomLinkForm: onHideInsertLoomLinkForm })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isReducedMotion = (0, $dWt6p.useIsReducedMotion)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const optimisticlyCreateLinkIdRef = (0, $5uXOq.useRef)();
    const validLinks = (0, $5uXOq.useMemo)(()=>links.filter((link)=>!('isCreateFailed' in link && link.isCreateFailed)), [
        links
    ]);
    const previousLinks = (0, $1XJ20.usePrevious)(links.filter($ada393559e8fa83c$var$isSmartAndNotFailedToDeleteWebLink));
    // This effect shows flags when a new Loom link is inserted (via recording or via adding an existing link)
    (0, $5uXOq.useEffect)(()=>{
        // Filtering out results of failed deletions (the link is deleted optimistically and if that fails it appears again)
        const smartLinks = links.filter($ada393559e8fa83c$var$isSmartAndNotFailedToDeleteWebLink);
        if (!optimisticlyCreateLinkIdRef.current) {
            // if we're here, we search for a newly created optimistic link
            const optimisticItem = smartLinks.filter((link)=>Object.hasOwnProperty.call(link, 'isCreateFailed'))// there might be other links that the user tried and failed to create before but we only care about the latest one.
            .pop();
            if (optimisticItem && // It's the first time we ever see this link (optimistic)
            !previousLinks?.find((link)=>link.smartLinkId === optimisticItem.smartLinkId)) optimisticlyCreateLinkIdRef.current = optimisticItem.smartLinkId;
            return;
        }
        // if we're here, an optimistic link we in the previous run was sent to the server and came back with a result we want to check
        const createdItem = smartLinks.find((link)=>link.smartLinkId === optimisticlyCreateLinkIdRef.current);
        optimisticlyCreateLinkIdRef.current = undefined;
        if (!createdItem) {
            // if we got here - it is a bug, should never happen
            (0, $jcw0u.default)({
                meta: {
                    id: 'showFlagLoomOptimisticLinkLookup',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        if ('isCreateFailed' in createdItem && createdItem.isCreateFailed) {
            showFlag({
                id: 'loomInsertLinkFailure',
                type: 'error',
                title: (0, $enHDY.messages).failureTitleLinkInserted,
                description: formatMessage((0, $enHDY.messages).failureLinkInserted),
                messageId: 'issue-view-base.content.loom-videos.ui.co-use.show-flag.error.loom-insert-link-failure',
                messageType: 'transactional'
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'loomInsertLink',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else showFlag({
            id: 'loomInsertLinkSuccess',
            type: 'success',
            title: (0, $enHDY.messages).successTitleLinkInserted,
            description: formatMessage((0, $enHDY.messages).successLinkInserted),
            messageId: 'issue-view-base.content.loom-videos.ui.co-use.show-flag.success.loom-insert-link-success',
            messageType: 'transactional',
            actions: [
                {
                    content: (0, $enHDY.messages).successActionShare,
                    onClick: ()=>{
                        if (typeof navigator !== 'undefined') navigator.clipboard.writeText(createdItem.href);
                    }
                }
            ]
        });
    }, [
        links,
        showFlag,
        formatMessage,
        previousLinks
    ]);
    // when cross flow succeeds, open the recorder
    (0, $fdGwF.useLoomRecorderTriggerListener)((0, $9PU8D.LoomRecorderTriggerEvent).CROSS_FLOW_SUCCESS, {
        entryPointLocation: 'jiraIssueView_quickAdd_crossflow',
        // TODO confirm what we want for these strings
        // intentionally not localized because Loom RecordSDK does not support i18n
        insertButtonText: 'Add video',
        onInsert: onInsertLink
    });
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    // animate and offset are used to control the LoomVideosList
    const [animate, setAnimate] = (0, $5uXOq.useState)(false);
    const [offset, setOffset] = (0, $5uXOq.useState)(0);
    // handleScroll is passed to the LoomVideosList to update the animate and offset states
    const handleScroll = (0, $5uXOq.useCallback)((e)=>{
        if (e.direction === 'left') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'loom-video-list-left-icon-button');
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'loom-video-list-right-icon-button');
        setOffset(e.offset);
        if (isReducedMotion) setAnimate(false);
        else setAnimate(e.animate);
    }, [
        analyticsEvent,
        isReducedMotion
    ]);
    const handleLinkInsert = async (url)=>{
        onInsertLink(url);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'insert-existing-loom-link-button');
        // reset the LoomVideosList to show the newly inserted link
        setOffset(0);
        if (isReducedMotion) setAnimate(false);
        else setAnimate(true);
    };
    const handleCancelLinkInsert = ()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancel-existing-loom-link-button');
        onHideInsertLoomLinkForm();
    };
    // only show the section heading if there are links or the insert link form is opened (this behavior is consistent with the existing web links implementation)
    const shouldShowSection = isInsertLoomLinkOpened || links.length > 0;
    const enableVisualRefreshChanges = (0, $dCm1o.isVisualRefreshEnabled)();
    if (!shouldShowSection && enableVisualRefreshChanges) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        testId: "issue-view-base.content.loom-videos.ui.co-use.container"
    }, shouldShowSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeading), {
        "data-testid": "issue-view-base.content.loom-videos.ui.co-use.heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeadingTitle), null, formatMessage((0, $enHDY.messages).loomVideosHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeadingIcons), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8NFbq.default), {
        onShowInsertLoomLinkForm: onShowInsertLoomLinkForm,
        onInsertLink: onInsertLink
    }))), validLinks.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8gnpg.LoomVideosList), {
        links: validLinks,
        animate: animate,
        offset: offset,
        onScroll: handleScroll,
        onDeleteLink: onDeleteLink
    }), isInsertLoomLinkOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aW8qI.LoomVideoInsert), {
        insertLoomLinkClickedCount: insertLoomLinkClickedCount,
        loomLinkCount: validLinks.length,
        onInsert: handleLinkInsert,
        onCancel: handleCancelLinkInsert
    }));
};

});
parcelRegister("fdGwF", function(module, exports) {

$parcel$export(module.exports, "useLoomRecorderTrigger", () => $ff5a2fc8dfa67bd9$export$3e559e51d1df0aaa);
$parcel$export(module.exports, "useLoomRecorderTriggerListener", () => $ff5a2fc8dfa67bd9$export$6121ceb7d7a8574b);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $fyQN8 = parcelRequire("fyQN8");
const $ff5a2fc8dfa67bd9$var$initialState = {
    triggers: new Set()
};
const $ff5a2fc8dfa67bd9$var$actions = {
    triggerLoomRecorder: (event)=>({ getState: getState, setState: setState })=>{
            const { triggers: triggers } = getState();
            triggers.add(event);
            setState({
                triggers: triggers
            });
        },
    markTriggered: (event)=>({ getState: getState, setState: setState })=>{
            const { triggers: triggers } = getState();
            triggers.delete(event);
            setState({
                triggers: triggers
            });
        }
};
const $ff5a2fc8dfa67bd9$var$store = (0, $iXqE5.createStore)({
    name: 'loom-utils.loom-recorder-trigger',
    initialState: $ff5a2fc8dfa67bd9$var$initialState,
    actions: $ff5a2fc8dfa67bd9$var$actions
});
const $ff5a2fc8dfa67bd9$var$useLoomRecorderTriggerStore = (0, $3sQ5x.createHook)($ff5a2fc8dfa67bd9$var$store);
const $ff5a2fc8dfa67bd9$export$3e559e51d1df0aaa = ()=>{
    const [, { triggerLoomRecorder: triggerLoomRecorder }] = $ff5a2fc8dfa67bd9$var$useLoomRecorderTriggerStore();
    return triggerLoomRecorder;
};
const $ff5a2fc8dfa67bd9$export$6121ceb7d7a8574b = (event, entrypointProps)=>{
    const [{ triggers: triggers }, { markTriggered: markTriggered }] = $ff5a2fc8dfa67bd9$var$useLoomRecorderTriggerStore();
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $fyQN8.useJiraLoomRecorderEntryPoint)({
        ...entrypointProps,
        skipInitialisation: entrypointProps.skipInitialisation || !triggers.has(event)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (// we "open" the recorder even if the initialisation has failed, so that the user is notified of it via error flags
        (recorderState === 'ready' || recorderState === 'initialisation-failed') && openLoomRecorder !== null && triggers.has(event)) {
            openLoomRecorder();
            markTriggered(event);
        }
    }, [
        event,
        markTriggered,
        openLoomRecorder,
        recorderState,
        triggers
    ]);
};

});
parcelRegister("fyQN8", function(module, exports) {

$parcel$export(module.exports, "useJiraLoomRecorderEntryPoint", () => $a858ac987e29a9d4$export$c1f08abbdaae3af1);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $gBfrj = parcelRequire("gBfrj");

var $eMXvl = parcelRequire("eMXvl");

var $apCzy = parcelRequire("apCzy");

var $5BHhW = parcelRequire("5BHhW");

var $4BRXm = parcelRequire("4BRXm");

var $1ElzW = parcelRequire("1ElzW");
function $a858ac987e29a9d4$var$reloadPage() {
    if (typeof window !== 'undefined') window.location.reload();
}
const $a858ac987e29a9d4$export$c1f08abbdaae3af1 = ({ entryPointLocation: entryPointLocation, onInsert: onInsert, insertButtonText: insertButtonText, renderOnInsertFallbackWhen: renderOnInsertFallbackWhen, skipInitialisation: skipInitialisation })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $5BHhW.useLoomTouchpointVariant)();
    const productName = (0, $eMXvl.useJiraLoomSDKProductName)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { hideBlanket: hideBlanket }] = (0, $apCzy.useLoomRecorderLoadingBlanket)();
    const { loomInitError: loomInitError, openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $gBfrj.useLoomRecorderEntryPoint)({
        environment: environment,
        cloudId: cloudId,
        productName: productName ?? 'UNKNOWN',
        skipInitialisation: skipInitialisation || loomTouchpointVariant !== (0, $4BRXm.LoomTouchpointVariant).COUSE,
        entryPointLocation: entryPointLocation,
        onInsert: (loomVideoUrl, video)=>{
            onInsert(loomVideoUrl, video);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomVideoLink inserted');
        },
        insertButtonText: insertButtonText,
        renderOnInsertFallbackWhen: renderOnInsertFallbackWhen,
        eventHandler: {
            // DONT USE OUR PATTERN, if you want, reach to us(Growth: Crossflow)
            // Loom has its own analytics event records, so due to the project schedule, we adopted the simplest method
            // and made a temporary version first. We will do the refactor after Loom's analytics are ready
            // (or if we find out that there is no intention on their end to do the integration any time soon)
            onStart: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'loomRecordingStart'),
            onRecordingStarted: ()=>(0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording started'),
            onCancel: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'loomRecordingCancel'),
            onComplete: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'loomRecordingComplete'),
            onRecordingComplete: ()=>(0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording completed'),
            onUploadComplete: ()=>(0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording uploaded'),
            onInsertClicked: (isInsertFallbackRendered)=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insertVideoLink', {
                    isInsertFallbackRendered: isInsertFallbackRendered
                })
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        if (loomInitError) hideBlanket();
    }, [
        loomInitError,
        hideBlanket
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // when cross-flowing, we need to hide the loading blanket at this point.
        // No harm hiding it when it's already hidden in other cases, though.
        if (recorderState === 'pre-recording') hideBlanket();
    }, [
        hideBlanket,
        recorderState
    ]);
    const fireMergeAccountsClickAnalytic = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent ?? createAnalyticsEvent({}), 'button clicked', 'loomRecorderErrorFlagMergeAccountsAction');
    }, [
        createAnalyticsEvent
    ]);
    const wrappedOpenLoomRecorder = (0, $5uXOq.useCallback)(()=>{
        if (loomInitError) {
            switch(loomInitError.type){
                case 'unsupported-browser':
                    showFlag({
                        id: 'loomInitErrorUnsupportedBrowser',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleInitFailed,
                        description: formatMessage((0, $1ElzW.default).errorInitFailedBrowserUnsupported),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-unsupported-browser',
                        messageType: 'transactional',
                        actions: [
                            {
                                content: (0, $1ElzW.default).errorActionBrowserUnsupported,
                                target: '_blank',
                                href: 'https://support.loom.com/hc/en-us/articles/360002228418-Can-I-use-Loom-with-Firefox-Safari-etc'
                            }
                        ]
                    });
                    break;
                case 'unsupported-third-party-cookie':
                    showFlag({
                        id: 'loomInitErrorCookie',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleInitFailed,
                        description: formatMessage((0, $1ElzW.default).errorInitFailedThirdPartyCookiesDisabled),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-cookie',
                        messageType: 'transactional'
                    });
                    break;
                case 'unsupported-media-streaming':
                    showFlag({
                        id: 'loomInitErrorUnsupportedMediaStreaming',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleInitFailed,
                        description: formatMessage((0, $1ElzW.default).errorInitFailedStreamingUnsupported),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-unsupported-media-streaming',
                        messageType: 'transactional'
                    });
                    break;
                case 'token-unsuccessful-unmerged-user':
                    showFlag({
                        id: 'loomInitErrorUnmergedUser',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleUnmergedAccount,
                        description: formatMessage((0, $1ElzW.default).errorUnmergedAccount),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-unmerged-user',
                        messageType: 'transactional',
                        actions: [
                            {
                                content: (0, $1ElzW.default).errorActionMergeAccounts,
                                target: '_blank',
                                href: environment === 'staging' ? 'https://stage.loom.com/merge-atlassian-profile' : 'https://www.loom.com/merge-atlassian-profile',
                                onClick: fireMergeAccountsClickAnalytic
                            }
                        ]
                    });
                    break;
                case 'loom-internal-error':
                default:
                    showFlag({
                        id: 'loomInitErrorInternal',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleInitFailed,
                        description: formatMessage((0, $1ElzW.default).errorInitFailedInternal),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-internal',
                        messageType: 'transactional',
                        actions: [
                            {
                                content: (0, $1ElzW.default).errorActionRefresh,
                                onClick: $a858ac987e29a9d4$var$reloadPage
                            }
                        ]
                    });
            }
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording refused', {
                reason: loomInitError.type
            });
            return;
        }
        const { isSuccess: isSuccess, failureReason: failureReason } = openLoomRecorder();
        if (!isSuccess) {
            hideBlanket();
            if (failureReason === 'already-recording') showFlag({
                id: 'loomAlreadyRecording',
                type: 'error',
                title: (0, $1ElzW.default).errorTitleRecordingAlreadyInProgress,
                description: formatMessage((0, $1ElzW.default).errorRecordingAlreadyInProgress),
                messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.show-flagloom-already-recording',
                messageType: 'transactional'
            });
            else if (failureReason === 'still-initialising') showFlag({
                id: 'loomStillInitialising',
                type: 'info',
                title: (0, $1ElzW.default).errorTitleSdkNotInitialized,
                description: formatMessage((0, $1ElzW.default).errorSdkNotInitialized),
                messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.info.loom-still-initialising',
                messageType: 'transactional'
            });
            else showFlag({
                id: 'loomUnknownError',
                type: 'error',
                title: (0, $1ElzW.default).errorTitleUnknown,
                description: formatMessage((0, $1ElzW.default).errorUnknown),
                messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-unknown-error',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $1ElzW.default).errorActionRefresh,
                        onClick: $a858ac987e29a9d4$var$reloadPage
                    }
                ]
            });
        }
        if (isSuccess) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomSdkRecorder opened', {
            entryPointLocation: entryPointLocation
        });
    }, [
        openLoomRecorder,
        showFlag,
        formatMessage,
        hideBlanket,
        loomInitError,
        createAnalyticsEvent,
        fireMergeAccountsClickAnalytic,
        environment,
        entryPointLocation
    ]);
    return {
        openLoomRecorder: wrappedOpenLoomRecorder,
        recorderState: recorderState
    };
};

});
parcelRegister("gBfrj", function(module, exports) {

$parcel$export(module.exports, "useLoomRecorderEntryPoint", () => $7879d9ef07c4028a$export$c8d9dc913e9e33ec);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $bSOOm = parcelRequire("bSOOm");

var $lw9xs = parcelRequire("lw9xs");

var $8kCPZ = parcelRequire("8kCPZ");

var $ftgXH = parcelRequire("ftgXH");
const $7879d9ef07c4028a$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, environment: environment, cloudId: cloudId, productName: productName, onInsert: onInsert, insertButtonText: insertButtonText, renderOnInsertFallbackWhen: renderOnInsertFallbackWhen, skipInitialisation: skipInitialisation, eventHandler: eventHandler })=>{
    const singletonLoomSDKRef = (0, $5uXOq.useRef)();
    const [loomInitError, setLoomInitError] = (0, $5uXOq.useState)();
    const [recorderState, setRecorderState] = (0, $5uXOq.useState)('initialising');
    const [userSegmentationData, setUserSegmentationData] = (0, $5uXOq.useState)({});
    const updateOnInsertIfUnmountedRef = (0, $5uXOq.useRef)();
    const experienceTracker = (0, $5uXOq.useContext)((0, $bSOOm.ExperienceTrackerContext));
    (0, $5uXOq.useEffect)(()=>{
        async function initLoom() {
            const initResult = await (0, $ftgXH.initLoomSDK)({
                environment: environment,
                cloudId: cloudId,
                productName: productName,
                experienceTracker: experienceTracker,
                entryPointLocation: entryPointLocation
            });
            if (initResult.kind === 'success') {
                singletonLoomSDKRef.current = initResult.loomSDKInstance;
                // TODO - we need to set this to the current state of the singleton (maybe it's already recording), but currently no way to subscibe to changes in the global state
                setRecorderState('ready');
            } else {
                setLoomInitError(initResult.initError);
                setRecorderState('initialisation-failed');
            }
        }
        if (!skipInitialisation) {
            initLoom();
            (0, $VSDnB.fg)('loom_examples_in_sdk_killswitch') && (0, $8kCPZ.getUserSegmentationData)().then((resp)=>{
                setUserSegmentationData({
                    jobTitle: resp.title,
                    teamType: resp.teamType
                });
            });
        }
    // Assumption - the dependencies cannot change without a full page regresh
    }, [
        environment,
        cloudId,
        productName,
        experienceTracker,
        skipInitialisation,
        entryPointLocation
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, $5uXOq.useEffect)(()=>{
        // this will run on unmount
        return function changeOnInsertBehaviorOnUnmount() {
            if (!singletonLoomSDKRef.current || !updateOnInsertIfUnmountedRef.current) return;
            if (renderOnInsertFallbackWhen === 'unmount') updateOnInsertIfUnmountedRef.current();
        };
    }, [
        renderOnInsertFallbackWhen
    ]);
    const openLoomRecorder = (0, $5uXOq.useCallback)(()=>{
        try {
            (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
            experienceTracker.start({
                id: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            // TODO - another instance can try to open the recorder while it's doing something else, we should disallow that by subscribing to the singleton state
            if (singletonLoomSDKRef.current === undefined) {
                (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                const failureReason = 'still-initialising';
                experienceTracker.abort({
                    name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                    reason: failureReason,
                    attributes: {
                        entryPointLocation: entryPointLocation
                    }
                });
                return {
                    isSuccess: false,
                    failureReason: failureReason
                };
            }
            if (singletonLoomSDKRef.current.status().state === 'active-recording') {
                (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                const failureReason = 'already-recording';
                experienceTracker.abort({
                    name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                    reason: failureReason,
                    attributes: {
                        entryPointLocation: entryPointLocation
                    }
                });
                return {
                    isSuccess: false,
                    failureReason: failureReason
                };
            }
            const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current;
            const sdkButton = configureButton();
            updateConfig({
                config: {
                    insertButtonText: insertButtonText,
                    entryPointName: entryPointLocation,
                    ...(0, $VSDnB.fg)('loom_examples_in_sdk_killswitch') && {
                        experimentalFeatures: {
                            teamType: userSegmentationData.teamType
                        }
                    }
                }
            });
            sdkButton.on('start', ()=>{
                eventHandler?.onStart?.();
            });
            sdkButton.on('recording-start', ()=>{
                eventHandler?.onRecordingStarted?.();
                setRecorderState('recording');
            });
            sdkButton.on('cancel', ()=>{
                eventHandler?.onCancel?.();
            });
            sdkButton.on('complete', ()=>{
                eventHandler?.onComplete?.();
            });
            sdkButton.on('recording-complete', (video)=>{
                eventHandler?.onRecordingComplete?.(video);
            });
            sdkButton.on('upload-complete', (video)=>{
                eventHandler?.onUploadComplete?.(video);
            });
            sdkButton.on('insert-click', (video)=>{
                onInsert(video.sharedUrl, video);
                eventHandler?.onInsertClicked?.(false);
                experienceTracker.succeed({
                    name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        inserted: true,
                        entryPointLocation: entryPointLocation
                    }
                });
            });
            updateOnInsertIfUnmountedRef.current = ()=>{
                updateConfig({
                    config: {
                        // TODO - format message?
                        insertButtonText: 'Open on Loom'
                    }
                });
                sdkButton.off('insert-click');
                sdkButton.on('insert-click', (video)=>{
                    if (typeof window !== 'undefined') {
                        window.open(video.sharedUrl, '_blank');
                        experienceTracker.succeed({
                            name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                            attributes: {
                                inserted: true,
                                insertFunctionWasReset: true,
                                entryPointLocation: entryPointLocation
                            }
                        });
                    }
                    eventHandler?.onInsertClicked?.(true);
                });
            };
            sdkButton.on('lifecycle-update', (lifecycleState)=>{
                if (lifecycleState === 'pre-recording') {
                    setRecorderState('pre-recording');
                    (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                } else if (lifecycleState === 'post-recording') {
                    if (typeof renderOnInsertFallbackWhen === 'function' && renderOnInsertFallbackWhen() && !!updateOnInsertIfUnmountedRef.current) updateOnInsertIfUnmountedRef.current();
                    setRecorderState('post-recording');
                } else if (lifecycleState === 'closed') {
                    setRecorderState('ready');
                    experienceTracker.succeed({
                        name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            closed: true,
                            entryPointLocation: entryPointLocation
                        }
                    });
                    updateOnInsertIfUnmountedRef.current = undefined;
                } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                    name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        cascaded: true,
                        entryPointLocation: entryPointLocation
                    }
                });
            });
            sdkButton.openPreRecordPanel();
            return {
                isSuccess: true
            };
        } catch (error) {
            (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            experienceTracker.fail({
                name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                error: error instanceof Error ? error : new Error('unknown error in openLoomRecorder'),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            return {
                isSuccess: false,
                failureReason: 'unexpected-error'
            };
        }
    }, [
        onInsert,
        entryPointLocation,
        insertButtonText,
        renderOnInsertFallbackWhen,
        experienceTracker,
        eventHandler,
        userSegmentationData.teamType
    ]);
    return loomInitError ? {
        recorderState: 'initialisation-failed',
        loomInitError: loomInitError,
        openLoomRecorder: null
    } : {
        openLoomRecorder: openLoomRecorder,
        loomInitError: null,
        recorderState: recorderState
    };
};

});
parcelRegister("lw9xs", function(module, exports) {

$parcel$export(module.exports, "OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC", () => $64e9d717812fd2f7$export$873f91e3be81ab94);
$parcel$export(module.exports, "INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC", () => $64e9d717812fd2f7$export$bf1068aa9f020d8f);
$parcel$export(module.exports, "RECORD_LOOM_ENTRY_POINT", () => $64e9d717812fd2f7$export$5e1aeeb6f31be57a);
$parcel$export(module.exports, "INITIALIZE_LOOM_ENTRY_POINT", () => $64e9d717812fd2f7$export$fdda1c9b501679e3);

var $dGrdR = parcelRequire("dGrdR");
const $64e9d717812fd2f7$export$873f91e3be81ab94 = (0, $dGrdR.metrics).interaction({
    key: 'open-loom-recorder-sdk'
});
const $64e9d717812fd2f7$export$bf1068aa9f020d8f = (0, $dGrdR.metrics).interaction({
    key: 'initialize-loom-recorder-sdk'
});
const $64e9d717812fd2f7$export$5e1aeeb6f31be57a = 'record-loom-entry-point';
const $64e9d717812fd2f7$export$fdda1c9b501679e3 = 'initialize-loom-entry-point';

});

parcelRegister("8kCPZ", function(module, exports) {

$parcel$export(module.exports, "getUserSegmentationData", () => $56959dc8d63b2133$export$f0a14a7cbbb7397e);
const $56959dc8d63b2133$var$LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY = 'loom-recorder.user-segmentation';
const $56959dc8d63b2133$var$handleFetchResponse = (response)=>{
    if (response.ok) return response.json();
    const error = new Error(`API responded with failure HTTP code: ${response.status}`);
    throw error;
};
const $56959dc8d63b2133$export$318c25600a19e2ee = async ()=>fetch('/gateway/api/me').then($56959dc8d63b2133$var$handleFetchResponse);
const $56959dc8d63b2133$export$f0a14a7cbbb7397e = async ()=>{
    // Try to read from local storage
    try {
        const cachedUserSegmentation = localStorage.getItem($56959dc8d63b2133$var$LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY);
        if (cachedUserSegmentation) return JSON.parse(cachedUserSegmentation);
    } catch (e) {
    // Ignore localStorage errors
    }
    try {
        const { extended_profile: extendedProfile } = await $56959dc8d63b2133$export$318c25600a19e2ee();
        const userSegmentationData = {
            title: extendedProfile.job_title,
            teamType: extendedProfile.team_type
        };
        // Save to local storage
        try {
            localStorage.setItem($56959dc8d63b2133$var$LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY, JSON.stringify(userSegmentationData));
        } catch (e) {
        // Ignore localStorage errors
        }
        return userSegmentationData;
    } catch (err) {
    // TODO add error analytics
    }
    return {};
};

});

parcelRegister("ftgXH", function(module, exports) {

$parcel$export(module.exports, "initLoomSDK", () => $a222f6be621da98e$export$a6ae7697c0f5af9d);
/* eslint-disable @repo/internal/import/no-unresolved */ 
var $lw9xs = parcelRequire("lw9xs");

var $3i33c = parcelRequire("3i33c");
const $a222f6be621da98e$export$703005ecc9b7c87e = {
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    UNSUPPORTED_MEDIA_STREAMING: 'unsupported-media-streaming',
    UNSUPPORTED_3RD_PARTY_COOKIE: 'unsupported-third-party-cookie',
    UNSUPPORTED_UNKNOWN: 'unsupported-unknown',
    TOKEN_UNSUCCESSFUL: 'token-unsuccessful',
    UNMERGED_USER: 'token-unsuccessful-unmerged-user',
    TOKEN_EMPTY: 'token-empty',
    NETWORK: 'network',
    LOOM_INTERNAL_ERROR: 'loom-internal-error',
    UNKNOWN: 'unknown'
};
class $a222f6be621da98e$var$LoomInitError extends Error {
    constructor(type, message){
        super(message);
        this.type = type;
    }
}
function $a222f6be621da98e$var$mapLoomUnsupportedTypeToSubType(unsupportedReason) {
    switch(unsupportedReason){
        case 'incompatible-browser':
            return $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_BROWSER;
        case 'third-party-cookies-disabled':
            return $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_3RD_PARTY_COOKIE;
        case 'no-media-streams-support':
            return $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_MEDIA_STREAMING;
        default:
            return $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_UNKNOWN;
    }
}
async function $a222f6be621da98e$var$fetchJsonFromUrl(url, method = 'GET', expectedStatuses = []) {
    try {
        const response = await fetch(url, {
            method: method,
            headers: {
                Accept: 'application/json'
            }
        });
        if (!response.ok && !expectedStatuses.includes(response.status)) throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.NETWORK, response.statusText);
        const data = await response.json();
        return data;
    } catch (error) {
        throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.NETWORK, error instanceof Error ? error.message : '');
    }
}
async function $a222f6be621da98e$var$getAuthToken() {
    const { token: token, message: message } = await $a222f6be621da98e$var$fetchJsonFromUrl('/gateway/api/loom-auth/api/internal/auth/sdk_token', 'POST', [
        404
    ]);
    if (message === 'Loom user needs merge') throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.UNMERGED_USER);
    if (message !== 'Success') {
        let userStatus;
        try {
            // we don't want a failure to make the identity check to mask the original issue
            const { status: status } = await $a222f6be621da98e$var$fetchJsonFromUrl('/gateway/api/loom-auth/api/internal/identity/user-status', 'GET');
            userStatus = status;
        } catch (error) {
            userStatus = 'unknown user status';
        }
        throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.TOKEN_UNSUCCESSFUL, `${message} , ${userStatus}`);
    }
    if (!token) throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.TOKEN_EMPTY);
    return token;
}


async function $a222f6be621da98e$var$_init({ cloudId: cloudId, environment: environment, productName: productName, experienceTracker: experienceTracker, entryPointLocation: entryPointLocation }) {
    let loomSDKInstance;
    try {
        (0, $lw9xs.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        experienceTracker.start({
            id: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
            name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        const { isSupported: isSupported } = await (parcelRequire("dt3ca"));
        const { supported: supported, error: error } = isSupported();
        if (!supported) throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$var$mapLoomUnsupportedTypeToSubType(error));
        const recorderToken = await $a222f6be621da98e$var$getAuthToken();
        const { createInstance: createInstance } = await (parcelRequire("i0rvQ"));
        loomSDKInstance = await createInstance((0, $3i33c.getLoomInstanceDataByEnvironment)({
            environment: environment,
            jws: recorderToken,
            siteId: cloudId,
            productName: productName,
            entryPointName: entryPointLocation
        }));
        if (!loomSDKInstance.status().success) throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.LOOM_INTERNAL_ERROR, 'Loom SDK timeout or another internal issue');
        experienceTracker.succeed({
            name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        (0, $lw9xs.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
    } catch (error) {
        (0, $lw9xs.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        if (error instanceof $a222f6be621da98e$var$LoomInitError) {
            if (error.type === $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_BROWSER || error.type === $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_MEDIA_STREAMING || error.type === $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_3RD_PARTY_COOKIE || error.type === $a222f6be621da98e$export$703005ecc9b7c87e.UNMERGED_USER) experienceTracker.succeed({
                name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            else experienceTracker.fail({
                name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
                error: new Error(error.type),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            return {
                kind: 'failure',
                initError: {
                    type: error.type,
                    message: error.message
                }
            };
        }
        experienceTracker.fail({
            name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
            error: new Error($a222f6be621da98e$export$703005ecc9b7c87e.UNKNOWN),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (error instanceof Error) return {
            kind: 'failure',
            initError: {
                type: $a222f6be621da98e$export$703005ecc9b7c87e.UNKNOWN,
                message: error.message
            }
        };
        return {
            kind: 'failure',
            initError: {
                type: $a222f6be621da98e$export$703005ecc9b7c87e.UNKNOWN
            }
        };
    }
    return {
        kind: 'success',
        loomSDKInstance: loomSDKInstance
    };
}
// this will hold our singleton result instance
let $a222f6be621da98e$var$initSDKResultPromise;
function $a222f6be621da98e$export$a6ae7697c0f5af9d(params) {
    // Singleton
    if ($a222f6be621da98e$var$initSDKResultPromise === undefined) $a222f6be621da98e$var$initSDKResultPromise = $a222f6be621da98e$var$_init(params);
    return $a222f6be621da98e$var$initSDKResultPromise;
}
function $a222f6be621da98e$export$1702a3de4c96a056() {
    $a222f6be621da98e$var$initSDKResultPromise = undefined;
}

});
parcelRegister("3i33c", function(module, exports) {

$parcel$export(module.exports, "getLoomInstanceDataByEnvironment", () => $ce96bc6823246afd$export$c150e4a8d8a3ab35);
const $ce96bc6823246afd$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $ce96bc6823246afd$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, productName: productName, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: productName,
            entryPointName: entryPointName
        }
    };
    if (environment === 'dev') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $ce96bc6823246afd$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production'
    };
    if (environment === 'staging') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $ce96bc6823246afd$var$PUBLIC_APP_IDS.staging,
        environment: 'staging'
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $ce96bc6823246afd$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production'
    };
};

});

parcelRegister("dt3ca", function(module, exports) {

let $9ce076484d3c551a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ce076484d3c551a$var$load("mtd6g").then(()=>parcelRequire('mesIh'));

});

parcelRegister("i0rvQ", function(module, exports) {

let $d1bd918a846611d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d1bd918a846611d5$var$load("ffQaD"),
    $d1bd918a846611d5$var$load("kvRbA"),
    $d1bd918a846611d5$var$load("2MUEn")
]).then(()=>parcelRequire('bpTSI'));

});



parcelRegister("1ElzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9df5f82f05fb80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $cc9df5f82f05fb80$var$messages = (0, $7VHMR.defineMessages)({
    errorTitleRecordingAlreadyInProgress: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-recording-already-in-progress",
        "defaultMessage": "Loom recorder unavailable"
    },
    errorRecordingAlreadyInProgress: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-recording-already-in-progress",
        "defaultMessage": "End the recording in progress before recording another Loom video."
    },
    errorTitleSdkNotInitialized: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-sdk-not-initialized",
        "defaultMessage": "The Loom recorder wasn\u2019t ready"
    },
    errorSdkNotInitialized: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-sdk-not-initialized",
        "defaultMessage": "Try to start recording again now."
    },
    errorTitleUnknown: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-unknown",
        "defaultMessage": "Failed to start recording"
    },
    errorUnknown: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-unknown",
        "defaultMessage": "Sorry, we couldn\u2019t start your recording. Please refresh the page and try again."
    },
    errorTitleInitFailed: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-init-failed",
        "defaultMessage": "Loom recorder unavailable"
    },
    errorInitFailedBrowserUnsupported: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-init-failed-browser-unsupported",
        "defaultMessage": "Switch to a different browser or turn off private browsing to continue recording."
    },
    errorInitFailedThirdPartyCookiesDisabled: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-init-failed-third-party-cookies-disabled",
        "defaultMessage": "Enable third party cookies in your browser to continue recording."
    },
    errorInitFailedStreamingUnsupported: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-init-failed-streaming-unsupported",
        "defaultMessage": "Your browser isn\u2019t supported - switch to a different browser to continue recording."
    },
    errorInitFailedInternal: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-init-failed-internal",
        "defaultMessage": "Refresh your browser to try again."
    },
    errorActionRefresh: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-action-refresh",
        "defaultMessage": "Refresh"
    },
    errorTitleUnmergedAccount: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-unmerged-account",
        "defaultMessage": "User not found"
    },
    errorUnmergedAccount: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-unmerged-account",
        "defaultMessage": "Merge your Atlassian and Loom profiles to access your account and available features."
    },
    errorActionMergeAccounts: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-action-merge-accounts",
        "defaultMessage": "Merge profiles"
    },
    errorActionBrowserUnsupported: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-action-browser-unsupported",
        "defaultMessage": "See supported browsers"
    }
});
var $cc9df5f82f05fb80$export$2e2bcd8739ae039 = $cc9df5f82f05fb80$var$messages;

});



parcelRegister("9PU8D", function(module, exports) {

$parcel$export(module.exports, "LoomRecorderTriggerEvent", () => $e839c52b56629c0b$export$8222a78bff6d77fd);
const $e839c52b56629c0b$export$8222a78bff6d77fd = {
    CROSS_FLOW_SUCCESS: 'cross-flow-success',
    // Created a separate JSM event trigger to avoid any accidental triggering from other touchpoints
    CROSS_FLOW_SUCCESS_FROM_JSM: 'cross-flow-success-from-jsm'
};

});

parcelRegister("enHDY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $17b245149dfc76be$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $17b245149dfc76be$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    loomVideosHeading: {
        "id": "issue-view-base.content.loom-videos.loom-videos-heading",
        "defaultMessage": "Loom videos"
    },
    loomCardErrorHeading: {
        "id": "issue-view-base.content.loom-videos.loom-card-error-heading",
        "defaultMessage": "An error has occurred"
    },
    successTitleLinkInserted: {
        "id": "issue-view-base.content.loom-videos.success-title-link-inserted",
        "defaultMessage": "Your Loom video has been added!"
    },
    successLinkInserted: {
        "id": "issue-view-base.content.loom-videos.success-link-inserted",
        "defaultMessage": "Copy the link to share it with your team."
    },
    successActionShare: {
        "id": "issue-view-base.content.loom-videos.success-action-share",
        "defaultMessage": "Copy link"
    },
    // TODO - finaliaze these messages
    failureTitleLinkInserted: {
        "id": "issue-view-base.content.loom-videos.failure-title-link-inserted.non-final",
        "defaultMessage": "Failed to add your Loom video"
    },
    failureLinkInserted: {
        "id": "issue-view-base.content.loom-videos.failure-link-inserted.non-final",
        "defaultMessage": "Please try again."
    }
});

});

parcelRegister("8NFbq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcca42ca052f20f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $aRoVz = parcelRequire("aRoVz");

var $99M5v = parcelRequire("99M5v");

var $koVbs = parcelRequire("koVbs");

var $5BHhW = parcelRequire("5BHhW");

var $4BRXm = parcelRequire("4BRXm");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jShfs = parcelRequire("jShfs");

var $hCaKe = parcelRequire("hCaKe");

var $iS2RO = parcelRequire("iS2RO");
const $bcca42ca052f20f9$var$LoomActionsMenu = ({ onShowInsertLoomLinkForm: onShowInsertLoomLinkForm, onInsertLink: onInsertLink })=>{
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $5BHhW.useLoomTouchpointVariant)();
    const handleOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownMenuOpen(isOpen);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), 'add-loom-icon-dropdown-menu', {
            isOpen: isOpen
        });
    }, [
        createAnalyticsEvent
    ]);
    // under cross-flow, we don't allow users to even add existing Looms
    if (loomTouchpointVariant === (0, $4BRXm.LoomTouchpointVariant).CROSSFLOW || loomTouchpointVariant === (0, $4BRXm.LoomTouchpointVariant).NONE) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        testId: "issue-view-base.content.loom-videos.ui.co-use.loom-actions-menu.drop-down-menu",
        defaultOpen: isDropdownMenuOpen,
        onOpenChange: handleOpenChange,
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                    LEGACY_size: "small",
                    color: "currentColor",
                    ...props,
                    label: formatMessage((0, $hCaKe.messages).label)
                }),
                ref: triggerRef,
                appearance: "subtle",
                spacing: "compact"
            }),
        shouldRenderToParent: true // This is needed to render the dropdown menu in the same container as the trigger instead of in React.Portal (otherwise domRef.current?.closest('[data-loom-insert-target-marker]' is undefined )
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iS2RO.RecordNewLoomItem), {
        onInsertLink: onInsertLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jShfs.default), {
        onShowInsertLoomLinkForm: onShowInsertLoomLinkForm
    })));
};
var $bcca42ca052f20f9$export$2e2bcd8739ae039 = $bcca42ca052f20f9$var$LoomActionsMenu;

});
parcelRegister("jShfs", function(module, exports) {

$parcel$export(module.exports, "default", () => $098915958da9577c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $b7NAp = parcelRequire("b7NAp");

var $eZ9Cp = parcelRequire("eZ9Cp");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3XBxg = parcelRequire("3XBxg");
const $098915958da9577c$var$InsertExistingLoomItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ onShowInsertLoomLinkForm: onShowInsertLoomLinkForm })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    });
    const handleShowInsertLoomLinkForm = (0, $5uXOq.useCallback)(()=>{
        onShowInsertLoomLinkForm();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'add-icon-button-dropdown-insert-existing-loom-video-button');
    }, [
        onShowInsertLoomLinkForm,
        analyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        elemBefore: (0, $4R6GH.fg)('quick_actions_menu_ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b7NAp))), {
            color: "currentColor",
            label: "",
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eZ9Cp))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        }),
        onClick: handleShowInsertLoomLinkForm
    }, (0, $4R6GH.fg)('quick_actions_menu_ga') ? formatMessage((0, $3XBxg.default).existingLoomVideo) : formatMessage((0, $3XBxg.default).insertExistingLoom));
});
var $098915958da9577c$export$2e2bcd8739ae039 = $098915958da9577c$var$InsertExistingLoomItem;

});
parcelRegister("3XBxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f46cb0d1d04bd015$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f46cb0d1d04bd015$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    insertExistingLoom: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.insert-existing-loom-item.insert-existing-loom",
        "defaultMessage": "Insert existing Loom"
    },
    existingLoomVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.insert-existing-loom-item.existing-loom-video",
        "defaultMessage": "Existing Loom video"
    }
});

});


parcelRegister("hCaKe", function(module, exports) {

$parcel$export(module.exports, "messages", () => $57dbe8e81fd04751$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $57dbe8e81fd04751$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.label",
        "defaultMessage": "Add a Loom video"
    }
});

});

parcelRegister("iS2RO", function(module, exports) {

$parcel$export(module.exports, "RecordNewLoomItem", () => $9d88feed58359adf$export$ebe73d592a7310ff);

var $5uXOq = parcelRequire("5uXOq");

var $5BHhW = parcelRequire("5BHhW");

var $4BRXm = parcelRequire("4BRXm");

var $5Vrrx = parcelRequire("5Vrrx");

var $cZ7VX = parcelRequire("cZ7VX");
const $9d88feed58359adf$export$ebe73d592a7310ff = ({ onInsertLink: onInsertLink })=>{
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $5BHhW.useLoomTouchpointVariant)();
    switch(loomTouchpointVariant){
        case (0, $4BRXm.LoomTouchpointVariant).COUSE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Vrrx.CoUseRecordItem), {
                onInsertLink: onInsertLink
            });
        case (0, $4BRXm.LoomTouchpointVariant).CROSSJOIN:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZ7VX.CrossJoinRecordItem), null);
        default:
            return null;
    }
};

});
parcelRegister("5Vrrx", function(module, exports) {

$parcel$export(module.exports, "CoUseRecordItem", () => $176d25428843609b$export$ba2e8fe50214cb1);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $aiLjp = parcelRequire("aiLjp");

var $aYAc3 = parcelRequire("aYAc3");

var $bUmQV = parcelRequire("bUmQV");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $fyQN8 = parcelRequire("fyQN8");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCzcE = parcelRequire("dCzcE");
const $176d25428843609b$export$ba2e8fe50214cb1 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onInsertLink: onInsertLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    });
    const domRef = (0, $5uXOq.useRef)(null);
    const insertTargetMarkerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        /* Once the user clicks the record button (this component),
     * the menu closes and this component, with all its hooks, unmounts.
     * When recording ends renderOnInsertFallbackWhen will run in order to determine
     * whether it is still possible to insert the link or not.
     * This is determined by whether the issue from which recording has started is still mounted.
     * This effect saves an identifier that the callback can use when it runs.
     */ insertTargetMarkerRef.current = domRef.current?.closest('[data-loom-insert-target-marker]')?.getAttribute('data-loom-insert-target-marker');
        if (!insertTargetMarkerRef.current) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'loomSdkInsertTargetMarker notFound', {
            touchpoint: 'loomSectionActionsMenuAddButton'
        });
    }, [
        createAnalyticsEvent
    ]);
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $fyQN8.useJiraLoomRecorderEntryPoint)({
        entryPointLocation: 'jiraIssueView_loomSectionActionsMenuAddButton',
        onInsert: onInsertLink,
        // intentionally not localized because Loom RecordSDK does not support i18n
        insertButtonText: 'Add video',
        renderOnInsertFallbackWhen: ()=>{
            if (typeof document !== 'undefined') return !insertTargetMarkerRef.current || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.querySelector('[data-loom-insert-target-marker]')?.getAttribute('data-loom-insert-target-marker') !== insertTargetMarkerRef.current;
            return false;
        }
    });
    const recordLoomVideo = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'add-icon-button-dropdown-record-a-video-button');
        openLoomRecorder?.();
    }, [
        analyticsEvent,
        openLoomRecorder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: "loom-section-actions-menu-recording-button",
        ref: domRef,
        elemBefore: recorderState === 'initialising' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "medium",
            label: formatMessage((0, $dCzcE.default).loading),
            testId: "issue-view-base.content.loom-videos.ui.co-use.loom-actions-menu.record-new-loom-item.co-use.recording-button-spinner"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aiLjp))), {
            label: formatMessage((0, $dCzcE.default).videoIcon),
            color: "currentColor",
            spacing: "spacious"
        }),
        onClick: recordLoomVideo,
        isDisabled: recorderState === 'initialising'
    }, (0, $4R6GH.fg)('quick_actions_menu_ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        gap: "space.050"
    }, formatMessage((0, $dCzcE.default).newLoomVideo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $dCzcE.default).newLozenge))) : formatMessage((0, $dCzcE.default).recordANewVideo));
});

});
parcelRegister("dCzcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6d6a8271338b80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $de6d6a8271338b80$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recordANewVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.record-a-new-video",
        "defaultMessage": "Record a video"
    },
    newLoomVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.new-loom-video",
        "defaultMessage": "New Loom video"
    },
    loomVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.loom-video",
        "defaultMessage": "Loom video"
    },
    loading: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.loading",
        "defaultMessage": "Loading"
    },
    videoIcon: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.video-icon",
        "defaultMessage": "Video icon"
    },
    tryLozenge: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.try-lozenge",
        "defaultMessage": "Try"
    },
    addLozenge: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.add-lozenge",
        "defaultMessage": "Add"
    },
    newLozenge: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.new-lozenge",
        "defaultMessage": "New"
    }
});

});


parcelRegister("cZ7VX", function(module, exports) {

$parcel$export(module.exports, "CrossJoinRecordItem", () => $80eb695c88ecdb1a$export$73968184b843a034);

var $5uXOq = parcelRequire("5uXOq");

var $c04PQ = parcelRequire("c04PQ");

var $6B7KL = parcelRequire("6B7KL");

var $aiLjp = parcelRequire("aiLjp");

var $aYAc3 = parcelRequire("aYAc3");

var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $cWTTi = parcelRequire("cWTTi");

var $1MBOO = parcelRequire("1MBOO");

var $4kmqE = parcelRequire("4kmqE");

var $kyWLB = parcelRequire("kyWLB");

var $4BRXm = parcelRequire("4BRXm");

var $eCbKV = parcelRequire("eCbKV");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cNd4s = parcelRequire("cNd4s");

var $dCzcE = parcelRequire("dCzcE");
const $80eb695c88ecdb1a$export$73968184b843a034 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const crossJoinUrl = (0, $1MBOO.useLoomCrossJoinUrl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isFedRampInstance = (0, $c04PQ.isFedRamp)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { dismissAd: dismissAd, loomTouchpointVariant: loomTouchpointVariant } = (0, $eCbKV.useLoomTouchpointVariantWithAdControls)((0, $kyWLB.LOOM_QUICK_ADD_AD_CONTROL_DISMISS_KEY));
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'add-icon-button-dropdown-record-a-video-cross-join-button', {
            isSiteAdmin: isSiteAdmin
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(crossJoinUrl, '_blank', 'noreferrer');
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        crossJoinUrl
    ]);
    return !isFedRampInstance && loomTouchpointVariant === (0, $4BRXm.LoomTouchpointVariant).CROSSJOIN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWTTi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: "loom-section-actions-menu-cross-join-recording-button",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aiLjp))), {
            label: formatMessage((0, $dCzcE.default).videoIcon),
            color: "currentColor",
            spacing: "spacious"
        }),
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.050",
        xcss: $80eb695c88ecdb1a$var$anchorStyles
    }, (0, $4R6GH.fg)('quick_actions_menu_ga') ? formatMessage((0, $dCzcE.default).loomVideo) : formatMessage((0, $dCzcE.default).recordANewVideo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, (0, $6s1PB.expValEquals)('jira_issue_view_loom_add_lozenge', 'cohort', 'variant') ? formatMessage((0, $dCzcE.default).addLozenge) : formatMessage((0, $dCzcE.default).tryLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        onClick: (e)=>{
            e.stopPropagation();
        },
        xcss: $80eb695c88ecdb1a$var$pressableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kmqE.default), {
        onDismiss: dismissAd,
        menuLocation: "quick-add"
    })))));
};
const $80eb695c88ecdb1a$var$pressableStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0'
});
const $80eb695c88ecdb1a$var$anchorStyles = (0, $8CUq3.xcss)({
    flexGrow: 1
});

});
parcelRegister("1MBOO", function(module, exports) {

$parcel$export(module.exports, "useLoomCrossJoinUrl", () => $b8913d0ba53efd1f$export$80677895f41c9591);

var $jfvbA = parcelRequire("jfvbA");

var $5euJh = parcelRequire("5euJh");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");
const $b8913d0ba53efd1f$export$80677895f41c9591 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const env = (0, $2tT7R.useEnvironment)();
    const continueUrl = env === 'prod' ? 'https://loom.com/api/auth/atlassian' : 'https://stage.loom.com/api/auth/atlassian';
    const identityDomain = (0, $5euJh.getATLContextUrl)('id');
    const userAccessUrl = `${identityDomain}/join/user-access?${new URLSearchParams({
        resource: (0, $jfvbA.LoomSiteAri).create({
            siteId: cloudId
        }).toString(),
        continue: continueUrl
    }).toString()}`;
    return `${identityDomain}/login?${new URLSearchParams({
        continue: userAccessUrl
    }).toString()}`;
};

});
parcelRegister("jfvbA", function(module, exports) {

$parcel$export(module.exports, "LoomSiteAri", () => $e0379be16ec952f6$export$5238cea8ab21c017);

var $h5dYQ = parcelRequire("h5dYQ");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/loom/site/manifest.ts
var $e0379be16ec952f6$var$loomSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $h5dYQ.LoomSiteAriResourceOwner),
    resourceType: (0, $h5dYQ.LoomSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/loom/site/index.ts
var $e0379be16ec952f6$export$5238cea8ab21c017 = class _LoomSiteAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e0379be16ec952f6$var$loomSiteAriStaticOpts.qualifier,
            platformQualifier: $e0379be16ec952f6$var$loomSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $e0379be16ec952f6$var$loomSiteAriStaticOpts.resourceOwner,
            resourceType: $e0379be16ec952f6$var$loomSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $e0379be16ec952f6$var$loomSiteAriStaticOpts);
        return new _LoomSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $e0379be16ec952f6$var$loomSiteAriStaticOpts);
        return new _LoomSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("h5dYQ", function(module, exports) {

$parcel$export(module.exports, "LoomSiteAriResourceOwner", () => $c6fdbf81c60516e5$export$6380f2e427a46ad9);
$parcel$export(module.exports, "LoomSiteAriResourceType", () => $c6fdbf81c60516e5$export$4d7aeb774da45763);
// src/loom/site/types.ts
var $c6fdbf81c60516e5$export$6380f2e427a46ad9 = "loom", $c6fdbf81c60516e5$export$4d7aeb774da45763 = "site";

});



parcelRegister("4kmqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd3c443f153ec75f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $bJeNF = parcelRequire("bJeNF");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bdFM8 = parcelRequire("bdFM8");
var $iB3Ak = parcelRequire("iB3Ak");
var $G85VY = parcelRequire("G85VY");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
var $2NMNM = parcelRequire("2NMNM");

var $cNd4s = parcelRequire("cNd4s");

var $eHOQZ = parcelRequire("eHOQZ");
const $bd3c443f153ec75f$var$DATA_PRIVACY_LINK = 'https://www.atlassian.com/legal/privacy-policy';
const $bd3c443f153ec75f$var$QUICK_MENU_TYPE = 'loom-only';
// AdControlProvider is needed when importing this component to provide the context for the AdControlDropdownMenu
const $bd3c443f153ec75f$var$AdControls = ({ onDismiss: onDismiss, menuLocation: menuLocation, bannerLocation: bannerLocation })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const eventAttributes = {
        bannerLocation: bannerLocation,
        menuLocation: menuLocation,
        isSiteAdmin: isSiteAdmin,
        quickMenuType: menuLocation === 'quick-add' ? $bd3c443f153ec75f$var$QUICK_MENU_TYPE : undefined
    };
    const buttonClicked = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const linkClicked = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bdFM8.default), {
        itemId: "loom-videos-banner-ad-controls",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    label: formatMessage((0, $eHOQZ.default).loomAdControlsTrigger),
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                ref: triggerRef,
                onClick: (event)=>{
                    props.onClick?.(event);
                    (0, $8zOmE.fireUIAnalytics)(buttonClicked, 'adControlsButton', eventAttributes);
                }
            }))
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iB3Ak.default), {
            ...props,
            flagProps: {
                title: formatMessage((0, $eHOQZ.default).dismissFlagTitle),
                description: formatMessage((0, $eHOQZ.default).dismissFlagDescription)
            },
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(buttonClicked, 'notInterestedButton', eventAttributes);
                return onDismiss();
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $G85VY.default), {
            ...props,
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(buttonClicked, 'whyAmISeeingThisButton', eventAttributes);
            },
            modalProps: {
                title: formatMessage((0, $eHOQZ.default).reasonsModalTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                    sourceName: "whyAmISeeingThis",
                    sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
                    onMount: (analyticsEvent)=>{
                        (0, $8zOmE.fireScreenAnalytics)(analyticsEvent, eventAttributes);
                    }
                }), formatMessage((0, $eHOQZ.default).reasonsModalExplanation, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                            weight: "bold"
                        }, chunks)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $eHOQZ.default).reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $eHOQZ.default).reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $bd3c443f153ec75f$var$linkStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    appearance: "link",
                    spacing: "none",
                    href: $bd3c443f153ec75f$var$DATA_PRIVACY_LINK,
                    target: "_blank",
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(linkClicked, 'dataPrivacyLink');
                    }
                }, formatMessage((0, $eHOQZ.default).privacyPolicy))))
            }
        })));
};
const $bd3c443f153ec75f$var$linkStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150'
});
var $bd3c443f153ec75f$export$2e2bcd8739ae039 = $bd3c443f153ec75f$var$AdControls;

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("eHOQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $adbd08717655a43b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $adbd08717655a43b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dismissFlagTitle: {
        "id": "loom-utils.ui.ad-controls.dismiss-flag-title",
        "defaultMessage": "Got it, thanks for letting us know"
    },
    dismissFlagDescription: {
        "id": "loom-utils.ui.ad-controls.dismiss-flag-description",
        "defaultMessage": "You won't see this here as often."
    },
    reasonsModalTitle: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-explanation",
        "defaultMessage": "We think that <strong>Loom</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-bullet-one",
        "defaultMessage": "the size of your team"
    },
    reasonsModalBulletTwo: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-bullet-two",
        "defaultMessage": "your existing Atlassian products"
    },
    privacyPolicy: {
        "id": "loom-utils.ui.ad-controls.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    loomAdControlsTrigger: {
        "id": "loom-utils.ui.ad-controls.loom-ad-controls-trigger",
        "defaultMessage": "Loom ad controls actions"
    }
});

});





parcelRegister("aW8qI", function(module, exports) {

$parcel$export(module.exports, "LoomVideoInsert", () => $3a41784d3c295607$export$e7101d4f7ce95cf3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $8jRgk = parcelRequire("8jRgk");
var $bUa6y = parcelRequire("bUa6y");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $b8JO7 = parcelRequire("b8JO7");

var $1XJ20 = parcelRequire("1XJ20");

var $9G8Sq = parcelRequire("9G8Sq");

var $6d5IR = parcelRequire("6d5IR");
const $3a41784d3c295607$var$InsertFormActions = ({ onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formState = (0, $bUa6y.useFormState)({
        values: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jRgk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        type: "submit",
        appearance: "primary",
        isDisabled: !(0, $6d5IR.canInsert)(formState?.values.url)
    }, formatMessage((0, $9G8Sq.default).insertButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $9G8Sq.default).cancelButton))));
};
const $3a41784d3c295607$export$e7101d4f7ce95cf3 = ({ insertLoomLinkClickedCount: insertLoomLinkClickedCount, loomLinkCount: loomLinkCount, onInsert: onInsert, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const resetRef = (0, $5uXOq.useRef)();
    const inputRef = (0, $5uXOq.useRef)(null);
    const prevInsertLoomLinkClickedCount = (0, $1XJ20.usePrevious)(insertLoomLinkClickedCount);
    const prevLoomLinkCount = (0, $1XJ20.usePrevious)(loomLinkCount);
    const focusOnInput = ()=>{
        /**
     * without this, the focus will not work as expected
     * issue persisted when using requestAnimationFrame instead of setTimeout
     * root cause is explained here https://hello.atlassian.net/wiki/spaces/~71202082ed214fcb8a401788d49831b11097a6/pages/4011824991/ED-24389+-+React18+editor+focus+issues
     *  - TLDR: When DropDown PopOver unmounts, useFocusManager forcing document focus.
     */ setTimeout(()=>{
            if (inputRef.current !== null) inputRef.current.focus({
                preventScroll: true
            });
        }, 100);
    // 100ms is a safe value to ensure the input is focused and user shouldn't notice the delay
    };
    (0, $5uXOq.useEffect)(()=>{
        // This will hapeen when user has successfully just inserted a link, we should re-focus on the input to let user insert another link
        if (prevLoomLinkCount !== undefined && loomLinkCount > prevLoomLinkCount) focusOnInput();
    }, [
        loomLinkCount,
        prevLoomLinkCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // this will handle the mount case (where prevInsertLoomLinkClickedCount is undefined) as well as the insert clicked again case
        if (insertLoomLinkClickedCount !== prevInsertLoomLinkClickedCount) {
            (0, $b8JO7.smoothScrollIntoCenterIfNeeded)(inputRef.current);
            focusOnInput();
        }
    }, [
        insertLoomLinkClickedCount,
        prevInsertLoomLinkClickedCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: ({ url: url })=>{
            if ((0, $6d5IR.canInsert)(url)) {
                const trimmedUrl = url.trim(); // a url with leadning/trailing spaces is valid but we want to trim it before inserting, otherwise the endpoint will reject it
                onInsert(trimmedUrl);
                // reset the text field after submitting
                resetRef.current?.();
            }
        }
    }, ({ formProps: formProps, reset: reset })=>{
        resetRef.current = reset;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            ...formProps,
            "data-testid": "issue-view-base.content.loom-videos.ui.co-use.loom-video-insert.form",
            className: (0, $bwpsq.default)([
                "_18z1t94y _1wpvt94y _ewaut94y _1hcdt94y"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "url",
            defaultValue: "",
            isRequired: true,
            validate: (value)=>(0, $6d5IR.shouldShowInvalidMessage)(value) ? 'INVALID_URL' : undefined
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ref: inputRef,
                ...fieldProps,
                placeholder: formatMessage((0, $9G8Sq.default).placeholderText),
                "aria-label": formatMessage((0, $9G8Sq.default).placeholderText),
                autoComplete: "off"
            }), error === 'INVALID_URL' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, formatMessage((0, $9G8Sq.default).invalidUrlText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a41784d3c295607$var$InsertFormActions, {
            onCancel: onCancel
        }));
    });
};
const $3a41784d3c295607$var$formStyles = null;

});
parcelRegister("8jRgk", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f31c1f2cf95b88$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $09f31c1f2cf95b88$var$formFooterWrapperStyles = null;
const $09f31c1f2cf95b88$var$justifyContentStyles = null;
function $09f31c1f2cf95b88$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("footer", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("9G8Sq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a64c62b28739944$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0a64c62b28739944$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    insertButton: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.insert-button",
        "defaultMessage": "Insert"
    },
    cancelButton: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.cancel-button",
        "defaultMessage": "Cancel"
    },
    placeholderText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.placeholder-text",
        "defaultMessage": "Add a Loom link"
    },
    invalidUrlText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.invalid-url-text",
        "defaultMessage": "Hold on, let's try a valid Loom link instead."
    }
});

});

parcelRegister("6d5IR", function(module, exports) {

$parcel$export(module.exports, "shouldShowInvalidMessage", () => $fb27a7d452df458e$export$4b698f3c1d0fae75);
$parcel$export(module.exports, "canInsert", () => $fb27a7d452df458e$export$b4d1262a40ad21d4);
/**
 * Determines if the URL is valid based on the standard Loom share URL pattern
 * @param shareUrl
 * @returns boolean
 * @example isUrlValid('https://www.loom.com/share/6d1794b0dd4c4a8495efa20d090c1602') // true
 * @example isUrlValid('https://stage.loom.com/share/Test-Recording-Video-9b7af208f71f45379a9f297bd065397a') // true
 * @example isUrlValid('https://www.youtube.com/watch?v=Hd0JflMdqyM') // false
 */ const $fb27a7d452df458e$export$c4ea027afed2fe4a = (shareUrl)=>{
    // strip query string
    try {
        const loomShareUrlPattern = /^\s*http(s)?:\/\/(www\.|stage\.)?(loom.com)\/(embed|share)\/(.+-)?([a-fA-F0-9]{32})(?:\?|$)/;
        const url = new URL(shareUrl);
        url.search = '';
        return loomShareUrlPattern.test(url.toString());
    } catch  {
        return false;
    }
};
const $fb27a7d452df458e$export$4b698f3c1d0fae75 = (shareUrl)=>{
    if (shareUrl === '') // we don't want to show an error message when the field is empty. especially when 'reset' is called after submitting, url is set to '' after that
    return false;
    if (shareUrl === undefined) return true;
    return !$fb27a7d452df458e$export$c4ea027afed2fe4a(shareUrl);
};
const $fb27a7d452df458e$export$b4d1262a40ad21d4 = (url)=>!$fb27a7d452df458e$export$4b698f3c1d0fae75(url) && url?.trim() !== '';

});


parcelRegister("8gnpg", function(module, exports) {

$parcel$export(module.exports, "LoomVideosList", () => $4e69cd88ebc0b8d3$export$cc3e92fb04a15d0);

var $5uXOq = parcelRequire("5uXOq");

var $30zXp = parcelRequire("30zXp");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");

var $40Yiq = parcelRequire("40Yiq");

var $PCgCA = parcelRequire("PCgCA");
const $4e69cd88ebc0b8d3$export$cc3e92fb04a15d0 = ({ links: links, animate: animate, offset: offset, onScroll: onScroll, onDeleteLink: onDeleteLink })=>{
    const [pendingDeleteId, setPendingDeleteId] = (0, $5uXOq.useState)(null);
    if (links.length === 0) return null;
    const handleDeleteLink = (id)=>{
        setPendingDeleteId(id);
    };
    const handleDeleteConfirm = (_, analyticsEvent)=>{
        if (pendingDeleteId !== null) onDeleteLink(pendingDeleteId);
        setPendingDeleteId(null);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'loom-video-lists-confirm-modal-delete-video');
    };
    const handleDeleteCancel = (_, analyticsEvent)=>{
        setPendingDeleteId(null);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'loom-video-lists-confirm-modal-cancel-delete-video');
    };
    // when there is only a single video, make it fill the available
    const videoCards = links.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.single",
        xcss: $4e69cd88ebc0b8d3$var$singleCardStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $PCgCA.default), {
        link: links[0],
        onDeleteLink: handleDeleteLink
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $30zXp.FilmstripView), {
        onScroll: onScroll,
        animate: animate,
        offset: offset
    }, links.slice().reverse() // we want the leftmost video to be the most recent one
    .map((l)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            key: l.id,
            testId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.multi",
            xcss: $4e69cd88ebc0b8d3$var$multiCardStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $PCgCA.default), {
            link: l,
            onDeleteLink: handleDeleteLink
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, videoCards, pendingDeleteId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $40Yiq.default), {
        onConfirm: handleDeleteConfirm,
        onCancel: handleDeleteCancel
    }));
};
const $4e69cd88ebc0b8d3$var$singleCardStyles = (0, $8CUq3.xcss)({
    maxWidth: '700px',
    minWidth: '380px',
    aspectRatio: '1.57894736842',
    marginBottom: 'space.100'
});
const $4e69cd88ebc0b8d3$var$multiCardStyles = (0, $8CUq3.xcss)({
    width: '380px',
    height: '240px',
    marginBottom: 'space.100'
});

});
parcelRegister("40Yiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $56756a4cabb2079d$export$2e2bcd8739ae039);
// ported from jira/src/packages/issue/issue-view-common-views/src/web-link-line-card-group/delete-modal/index.tsx

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $ctbYY = parcelRequire("ctbYY");
const $56756a4cabb2079d$export$73392e09138fecd6 = ({ onConfirm: onConfirm, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const headerMessage = formatMessage((0, $ctbYY.messages).headerMessage);
    const contentMessage = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $ctbYY.messages).contentMessageIssueTermRefresh : (0, $ctbYY.messages).contentMessage);
    const confirmActionText = formatMessage((0, $ctbYY.messages).confirmActionText);
    const cancelActionText = formatMessage((0, $ctbYY.messages).cancelActionText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.delete-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancel,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "danger"
    }, headerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, contentMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: onConfirm
    }, confirmActionText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onCancel
    }, cancelActionText)))));
};
var $56756a4cabb2079d$export$2e2bcd8739ae039 = $56756a4cabb2079d$export$73392e09138fecd6;

});
parcelRegister("ctbYY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $210e11e0dfb2bf17$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $210e11e0dfb2bf17$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    headerMessage: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.header-message",
        "defaultMessage": "Remove this Loom video link?"
    },
    contentMessage: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.content-message",
        "defaultMessage": "This will unlink the video from the issue."
    },
    confirmActionText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.confirm-action-text",
        "defaultMessage": "Remove"
    },
    cancelActionText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.cancel-action-text",
        "defaultMessage": "Cancel"
    },
    contentMessageIssueTermRefresh: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.content-message-issue-term-refresh",
        "defaultMessage": "This will unlink the video."
    }
});

});


parcelRegister("PCgCA", function(module, exports) {

$parcel$export(module.exports, "default", () => $26046c2200ff212e$export$2e2bcd8739ae039);

var $hxqfC = parcelRequire("hxqfC");

var $1gC8Z = parcelRequire("1gC8Z");

var $9AKB1 = parcelRequire("9AKB1");
var $26046c2200ff212e$export$2e2bcd8739ae039 = (0, $hxqfC.connect)(null, (dispatch, { link: { id: linkId } })=>({
        onDeleteWebLinkRetry: ()=>{
            dispatch((0, $1gC8Z.deleteWebLinkRequest)(linkId));
        }
    }))((0, $9AKB1.LoomVideoCard));

});
parcelRegister("9AKB1", function(module, exports) {

$parcel$export(module.exports, "LoomVideoCard", () => $962df776ae5ed5fe$export$f91bff7396e50278);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $bU3PY = parcelRequire("bU3PY");

var $kVZJG = parcelRequire("kVZJG");

var $dGrdR = parcelRequire("dGrdR");

var $jcw0u = parcelRequire("jcw0u");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");

var $cKlMK = parcelRequire("cKlMK");

var $2zZd6 = parcelRequire("2zZd6");
const $962df776ae5ed5fe$export$f30594ea7fd7a441 = 'deleteLoomVideoLinkFailed';
const $962df776ae5ed5fe$export$3ba67dfd4f739fe9 = (0, $dGrdR.metrics).interaction({
    key: 'issue-view.loom-videos-card-load'
});
const $962df776ae5ed5fe$export$f91bff7396e50278 = ({ link: link, onDeleteLink: onDeleteLink, onDeleteWebLinkRetry: onDeleteWebLinkRetry })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { deleteFailed: deleteFailed } = link;
    const prevDeleteFailed = (0, $1XJ20.usePrevious)(deleteFailed);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [errorStatus, setErrorStatus] = (0, $5uXOq.useState)(undefined);
    const [isCardLoaded, setIsCardLoaded] = (0, $5uXOq.useState)(false);
    const [isDeleteButtonClicked, setDeleteButtonClicked] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        isCardLoaded ? $962df776ae5ed5fe$export$3ba67dfd4f739fe9.stop() : $962df776ae5ed5fe$export$3ba67dfd4f739fe9.start();
    }, [
        isCardLoaded
    ]);
    (0, $5uXOq.useEffect)(()=>{
        errorStatus && (0, $jcw0u.default)({
            meta: {
                id: 'loomVideoCardLoad',
                packageName: 'jiraIssueViewBase',
                teamName: 'bento'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        errorStatus
    ]);
    const handleError = ({ status: status })=>{
        setErrorStatus(status);
        setIsCardLoaded(true);
    };
    const handleResolve = ()=>{
        setIsCardLoaded(true);
    };
    const handleDeleteLink = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'delete-loom-video-card-button');
        onDeleteLink(link.id);
        setDeleteButtonClicked(true);
    };
    const showDeleteErrorFlag = (0, $5uXOq.useCallback)(()=>{
        const flagId = (0, $7HGHK.toFlagId)($962df776ae5ed5fe$export$f30594ea7fd7a441);
        showFlag({
            messageId: 'issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.loom-video-card.show-flag.warning.delete-error',
            messageType: 'transactional',
            id: flagId,
            title: (0, $2zZd6.messages).deleteErrorHeading,
            description: (0, $2zZd6.messages).errorBody,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                label: formatMessage((0, $2zZd6.messages).iconLabel),
                color: "var(--ds-icon-warning, #E56910)",
                spacing: "spacious"
            }),
            type: 'warning',
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, $2zZd6.messages).retryAction,
                    onClick: ()=>{
                        dismissFlag(flagId);
                        onDeleteWebLinkRetry();
                    }
                },
                {
                    content: (0, $2zZd6.messages).cancelAction,
                    onClick: ()=>{
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        onDeleteWebLinkRetry,
        dismissFlag,
        showFlag,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (deleteFailed && deleteFailed !== prevDeleteFailed) {
            showDeleteErrorFlag();
            (0, $jcw0u.default)({
                meta: {
                    id: 'loomVideoCardDeletion',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        deleteFailed,
        prevDeleteFailed,
        showDeleteErrorFlag
    ]);
    const card = errorStatus === 'errored' || errorStatus === 'unauthorized' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKlMK.LoomErrorCard), {
        url: link.href
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVZJG.Card), {
        url: link.href,
        appearance: "embed",
        platform: "web",
        frameStyle: "show",
        inheritDimensions: true,
        onError: handleError,
        onResolve: handleResolve
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c82smr _4t3i1osq _kqswh2mm _vtqp1osq _8kgukb7n _wjvokb7n"
        ])
    }, card, isCardLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-show-on-hover": "true",
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsboahv _19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _4t3i1ejb _1pbykb7n _154iidpf _1xi2idpf _1e0c1txw _4cvr1h6o _1bahesu3 _tzy4idpf _1itk11xj"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))),
        appearance: "subtle",
        label: formatMessage((0, $2zZd6.messages).removeButtonLabel),
        spacing: "compact",
        onClick: handleDeleteLink,
        onFocus: (e)=>{
            // after we click cancel button in delete confirmation dialog, the focus goes back to this close icon button
            if (!isDeleteButtonClicked) return;
            e.target.blur();
            setDeleteButtonClicked(false);
        }
    })));
};
// can't use xcss here since we have to nest CSS for .loader-wrapper
const $962df776ae5ed5fe$var$wrapperStyles = null; // this is a little absolute positioned element on the top-right of the smart card to show an "x" button
const $962df776ae5ed5fe$var$closeWrapperStyles = null;

});
parcelRegister("cKlMK", function(module, exports) {

$parcel$export(module.exports, "LoomErrorCard", () => $47ee52cd00b93bb9$export$fd3b8d345f1c673);

var $5uXOq = parcelRequire("5uXOq");

var $hMVoD = parcelRequire("hMVoD");

var $90mMF = parcelRequire("90mMF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $HEA7j = parcelRequire("HEA7j");

var $koVbs = parcelRequire("koVbs");

var $f7CQF = parcelRequire("f7CQF");

var $enHDY = parcelRequire("enHDY");
const $47ee52cd00b93bb9$export$fd3b8d345f1c673 = ({ url: url })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $HEA7j.ExpandedFrame), {
        allowScrollBar: true,
        setOverflow: true,
        frameStyle: "show",
        href: url,
        inheritDimensions: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($90mMF))), {
            label: "Unlink",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.loom-video-card.loom-error-card.error-view",
        text: url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $47ee52cd00b93bb9$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        label: "Error",
        color: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeadingTitle), null, formatMessage((0, $enHDY.messages).loomCardErrorHeading))));
};
const $47ee52cd00b93bb9$var$contentStyles = (0, $8CUq3.xcss)({
    textAlign: 'center',
    alignContent: 'center',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    height: '100%'
});

});
parcelRegister("90mMF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d32cfb464fc797f765cf705a7186f08e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68e5c989bea2984f$var$_react = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $68e5c989bea2984f$var$_baseNew = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $68e5c989bea2984f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68e5c989bea2984f$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $68e5c989bea2984f$var$_react.default.createElement($68e5c989bea2984f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$68e5c989bea2984f$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $68e5c989bea2984f$var$_default = module.exports.default = $68e5c989bea2984f$var$LinkBrokenIcon;

});


parcelRegister("2zZd6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6db6ff2bf64469c5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6db6ff2bf64469c5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    removeButtonLabel: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.remove-button-label",
        "defaultMessage": "Remove linked Loom"
    },
    deleteErrorHeading: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.delete-error-heading",
        "defaultMessage": "Loom video not removed"
    },
    errorBody: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.error-body",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    iconLabel: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.icon-label",
        "defaultMessage": "warning"
    },
    retryAction: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.retry-action",
        "defaultMessage": "Try again"
    },
    cancelAction: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.cancel-action",
        "defaultMessage": "Cancel"
    }
});

});









//# sourceMappingURL=async-loom-videos-panel.4658c771.js.map
